/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { FunctionComponent } from 'react'

import { routes, useCoordinator } from '@builddocs/data-management'
import { Box, Typography } from '@mui/material'
import { Scrollbars } from 'react-custom-scrollbars'
import { useNavigate } from 'react-router-dom'

import { ContainerTree } from './ContainerTree'
import NavLinks from './NavLinks'
import { ProjectsSelector } from './ProjectsSelector'

const ProjectsNavWidget: FunctionComponent = () => {
  const navigate = useNavigate()

  const { projectId, contractId } = useCoordinator()

  const changeProject = projectId => {
    navigate(routes.projects.project(projectId))
  }
  const tryToCreateContract = () => {
    const code = window.prompt('Введите код. Его можно запросить в поддержке.')

    if (code === '9103324645') {
      navigate(`/projects/${projectId}/contracts/create`)
    }
  }

  if (!projectId) return null

  return (
    <>
      <ProjectsSelector onChange={changeProject} />
      <NavLinks currentProjectId={projectId} />
      <Box display="flex" justifyContent="space-between">
        <Typography color="text.secondary" ml={1.5} mt={1} variant="overline">
          Договоры
        </Typography>
        <Box
          sx={{ marginLeft: 1.5, marginTop: 1, cursor: 'pointer' }}
          onClick={() => tryToCreateContract()}
        >
          <Typography
            color="#0034AD"
            sx={{ textDecoration: 'none' }}
            variant="overline"
          >
            [ + ]
          </Typography>
        </Box>
      </Box>
      <Box
        component={Scrollbars}
        flexGrow={1}
        overflow="auto"
        sx={{ minHeight: 200 }}
      >
        <ContainerTree
          currentContractId={contractId}
          currentProjectId={projectId}
        />
      </Box>
    </>
  )
}

export default ProjectsNavWidget
